import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const EcofriendlyGiftsforalloccasions =()=>{
    const CTAContent = [
        {
          pageName: "Eco-Friendly Gifts for All Occasions",
          paragraphitalic: "Gift Green, Live Green",
          paragraphText:
                "Whether it’s a festival, a birthday, or a special celebration, our eco-friendly gift solutions cater to every occasion. Show your care for both the employee and the planet with sustainable, personalized gifts that make an impact.",
          ContactFormName: "Eco-Friendly Gifts for All Occasions",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Zero-Waste Kits",
          parapgraphItalic: "Embrace a Zero-Waste Lifestyle – One Kit at a Time!",
          sectionparagraphText: (
            <>
              <p>
              Essential kits that make sustainability simple, stylish, and practical. 
                </p>
                <p>
            Step into the zero-waste movement with thoughtfully curated kits that help reduce everyday waste. Packed with eco-friendly essentials like reusable cutlery, cloth bags, and biodegradable toiletries, our kits are perfect for gifting or personal use. Designed for practicality and sustainability, these kits are your first step toward a greener future. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Eco-Friendly Gifts for All Occasions/Zero-Waste Kits.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Plantable Paper and Eco Cards",
          parapgraphItalic: "Send Greetings That Grow!",
          sectionparagraphText: (
            <>
              <p>
                Eco-friendly paper products that bloom into beautiful plants. 
                </p>
                <p>
                Turn your messages into meaningful memories with plantable paper and eco-cards. Made from biodegradable materials embedded with seeds, these products offer a delightful way to combine thoughtfulness and sustainability. Perfect for festive greetings, corporate thank-you notes, or event invites, they bring the joy of gifting full circle. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Eco-Friendly Gifts for All Occasions/Plantable Paper and Eco Cards.jpg",
          categoryHeadingLeftSide: "Features That Grow on You",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for All Occasions/Plantable Cards.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Plantable Cards</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for All Occasions/Eco-Friendly Invitations.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Eco-Friendly Invitations</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for All Occasions/Custom Designs Available.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Custom Designs Available</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for All Occasions/Features That Minimize Your Impact.jpg",
          NogapHeading: "Features That Minimize Your Impact",
          Heading: [
            {
              ListHeading: "Everyday Essentials",
              ListParagraph:
                "Includes reusable straws, bamboo cutlery, cloth napkins, and more.",
            },
            {
              ListHeading: "Travel-Friendly",
              ListParagraph:
                "Compact and lightweight, perfect for eco-conscious travelers.",
            },
            {
              ListHeading: "Customizable Options",
              ListParagraph:
                "Tailor the kits to suit your preferences or branding needs.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for All Occasions/Sustainable Gift Wrap Options.jpg",
          NogapHeading: "Sustainable Gift Wrap Options",
          paragraphItalic: "Wrap It Right – The Sustainable Way!",
          paragraphDetail: (
            <>
              <p>
              Eco-conscious wrapping solutions that elevate your gifts and protect the planet. 
                </p>
                <p>
                Redefine the art of gifting with our sustainable gift wrap options. From reusable fabric wraps to compostable paper and jute twine, every element of your gift’s presentation can now reflect your eco-friendly values. Perfect for personal celebrations or corporate events, these wraps ensure your gifts look as good as they feel for the planet. 
              </p>
            </>
          ),
    
          NogapSubheading: "Features That Make an Impact",
          Categories: [
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for All Occasions/Reusable Fabric Wraps.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Reusable Fabric Wraps</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for All Occasions/Biodegradable Paper.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Biodegradable Paper</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for All Occasions/Decorative Add-Ons.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Decorative Add-Ons</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
        <title>"eYantra Eco-Friendly Corporate Gifts</title>
        <meta name="description" content="eYantra offers eco-friendly gifts, branded merchandise, joining kits, and company merchandise for corporate gifting across Hyderabad and beyond."/>
        <meta name="keywords" content="eyantra, eco friendly gifts,  branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits,company merchandise, corporate gifts in hyderabad"/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Celebrate life’s moments with gifts that reflect your commitment to a brighter, greener future. 
      </p>
    </>
  );
};

export default EcofriendlyGiftsforalloccasions;